<section class="finder" id="finder">
  <div class="wrap">
    <div class="head">
      <span class="eyebrow">Now try yours</span>
      <p class="stmt">Every name gets an answer. Including no.</p>
      <p>We run your name against every British format and the full substitution alphabet. If it cannot
        be written, we will tell you which letter stopped it.</p>
    </div>
    <div class="fbox">
      <div class="finput">
        <input id="finderInput" type="text" placeholder="Type a first name"
               autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="words"
               inputmode="text" enterkeyhint="search" maxlength="40"
               aria-label="Name to look up" [value]="term"
               (input)="onInput($any($event.target).value)"
               (keydown.enter)="run()"/>
        <button class="btn btn--green" (click)="run()">Look it up</button>
      </div>
      <div class="fsug">
        <button *ngFor="let s of suggestions" (click)="run(s)">{{ s }}</button>
      </div>

      <!-- the verdict changes without navigation: announce it -->
      <div class="verdict" aria-live="polite" aria-atomic="true">
        <ng-container *ngIf="state === 'loading'">
          <div class="v-loading">Checking {{ term }}…</div>
        </ng-container>

        <ng-container *ngIf="state === 'error'">
          <div class="v-error">We could not check that just now. Please try again.
            <button class="v-retry" (click)="run()">Retry</button></div>
        </ng-container>

        <ng-container *ngIf="state === 'result' && result as r">
          <!-- guidance outcomes: not one of the three verdicts -->
          <div class="v-guidance" *ngIf="r.outcome === 'ROMANISATION_REQUIRED'">
            <div class="tier tier-guide">Romanised form needed</div>
            <p class="say">{{ r.message }}</p>
          </div>
          <div class="v-guidance" *ngIf="r.outcome === 'INVALID_INPUT'">
            <p class="say">{{ r.message }}</p>
          </div>

          <!-- can-write / can-write-no-record -->
          <ng-container *ngIf="r.verdict === 'can-write' || r.verdict === 'can-write-no-record'">
            <div class="tier" [class.tier-yes]="r.verdict === 'can-write'" [class.tier-maybe]="r.verdict === 'can-write-no-record'">
              {{ r.verdict === 'can-write' ? 'Can be written' : 'Can be written · no record of issue' }}
            </div>
            <div class="nm">{{ r.input.normalised | titlecase }}</div>
            <div class="arrangements">
              <a class="arr" *ngFor="let a of r.arrangements"
                 [routerLink]="plateLink(a.registration)"
                 [attr.aria-label]="a.display + ', ' + a.substitutions + ' character' + (a.substitutions === 1 ? '' : 's') + ' standing in, ' + arrangementState(a)">
                <span class="plate md" [class.muted]="a.state !== 'new-issue' && a.state !== 'resale'"><span class="ch"><ng-container
                  *ngFor="let c of chars(a.display)"><span [class.sub]="c.sub">{{ c.ch }}</span></ng-container></span></span>
                <span class="arr-meta"><b>{{ a.era | titlecase }}</b> · {{ arrangementState(a) }}</span>
              </a>
            </div>
            <!-- onward discovery even when a perfect name exists (#7) -->
            <button class="fsearch" (click)="searchName()">{{ searchLabel }} →</button>
          </ng-container>

          <!-- cannot-write: give the reason, then lead onward to real plates (#7) -->
          <ng-container *ngIf="r.verdict === 'cannot-write'">
            <div class="tier tier-no">No perfect spelling</div>
            <div class="nm">{{ r.input.normalised | titlecase }}</div>
            <p class="say" *ngIf="r.reason?.code === 'TOO_LONG'">
              {{ r.input.normalised | titlecase }} is {{ r.reason?.detail?.length }} letters. A British
              registration is {{ r.reason?.detail?.ceiling }} characters, so it cannot be spelled exactly.
            </p>
            <p class="say" *ngIf="r.reason?.code === 'BLOCKED_LETTERS'">
              <b>{{ blockedLetters() }}</b> {{ (r.reason?.detail?.letters?.length || 0) > 1 ? 'have' : 'has' }}
              no numeral form, so no arrangement spells it exactly. It misses on shape, not on rarity.
            </p>
            <p class="say" *ngIf="r.reason?.code === 'NO_ARRANGEMENT'">
              No arrangement spells {{ r.input.normalised | titlecase }} exactly under the plate alphabet.
            </p>
            <p class="onward">But the search does not end here.</p>
            <button class="fsearch" (click)="searchName()">{{ searchLabel }} →</button>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</section>
